import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { UrjanetLoginModalForm } from './form';
import { SimpleModal, Icon } from '@livable/saas-react-components';
export const UrjanetLoginModal = observer(_ref => {
  let companyCredentials = _ref.companyCredentials,
    providerInfo = _ref.providerInfo,
    propertyId = _ref.propertyId,
    customTrigger = _ref.customTrigger,
    propertyUtility = _ref.propertyUtility,
    callbackTrigger = _ref.callbackTrigger,
    isEdit = _ref.isEdit;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t('add_new_property_flow.urjanet_login'),
    trigger: customTrigger !== undefined ? customTrigger : /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('add_new_property_flow.urjanet_login')))
  }, /*#__PURE__*/React.createElement(UrjanetLoginModalForm, {
    providerInfo: providerInfo,
    companyCredentials: companyCredentials,
    propertyId: propertyId,
    propertyUtility: propertyUtility,
    callbackTrigger: callbackTrigger,
    isEdit: isEdit
  }));
});